
import { oz } from '@weft/utils';
import { ID_PATTERN } from './object-id-schema-consts';

export const ObjectIdSchema = oz.string().regex(ID_PATTERN, 'Invalid ObjectId');

export type ObjectId = oz.infer<typeof ObjectIdSchema>;
